import { LandingAuthorFragment, LandingMetadataFragment } from "types/api";
import styles from "./LandingMetadata.module.scss";
import { gql } from "utils/urql";
import { formatArticleDate } from "utils/date";
import Authors from "components/Authors";
/**
 * Refers to the different parts of the page that can have click tracking
 * applied to them.
 */
type LandingPageAnalyticsSection = "featured" | "project" | "river";

const Author = ({
  slug,
  displayName,
  analyticsSection,
  riverIndex,
}: LandingAuthorFragment & {
  analyticsSection: LandingPageAnalyticsSection;
  riverIndex?: number;
}) => {
  return (
    <a
      href={`https://www.theatlantic.com/author/${slug}`}
      className={styles.author}
      data-action={`click link - ${analyticsSection} - author${
        riverIndex ? ` ${riverIndex}` : ""
      }`}
    >
      {displayName}
    </a>
  );
};

const LandingMetadata = ({
  authors,
  datePublished,
  analyticsSection,
  riverIndex,
  ...props
}: LandingMetadataFragment & {
  analyticsSection: LandingPageAnalyticsSection;
  riverIndex?: number;
}) => {
  return (
    <p className={styles.root}>
      {authors.length > 0 && (
        <span className={styles.byline}>
          <Authors
            authors={authors}
            component={Author}
            analyticsSection={analyticsSection}
            riverIndex={riverIndex}
          />
        </span>
      )}
      {props.__typename === "MagazineArticle" ? (
        <a href={props.issue.url} className={styles.issue}>
          {props.issue.issueName}
        </a>
      ) : (
        datePublished && (
          <time className={styles.datePublished} dateTime={datePublished}>
            {formatArticleDate(datePublished)}
          </time>
        )
      )}
    </p>
  );
};

LandingMetadata.fragment = gql`
  fragment landingIssue on MagazineArticle {
    issue {
      issueName
      url
    }
  }

  fragment landingAuthor on Author {
    id
    slug
    displayName
  }

  fragment landingMetadata on PromoItem {
    datePublished
    authors {
      ...landingAuthor
    }
    ...landingIssue
  }
`;

export default LandingMetadata;
